<template>
    <div class="vf-loading-wrapper">
        <transition
            name="fade-fast"
            mode="out-in"
        >
            <div
                v-if="isSuccessful"
                key="success"
            >
                <slot />
            </div>
            <div
                v-if="isPending"
                key="pending"
                class="vf-spinning-loader-wrapper"
            >
                <vf-spinning-loader
                    size="large"
                />
            </div>
            <slot
                v-if="hasError"
                name="error"
            >
                <div class="vf-spinning-loader-wrapper">
                    <cta-state
                        :status="error"
                        :title="errorMessage"
                        :subtitle="errorSubtitle"
                        :actions="actions"
                        @cta-clicked="$emit('cta-clicked')"
                    />
                </div>
            </slot>
        </transition>
    </div>
</template>

<script>
import VueTypes from 'commons/util/vue-types.js';
import ctaState from '@/components/common/CtaState.vue';
import vfSpinningLoader from 'design-assets/components/inline_loader/spinning-loader.vue';

import { ICON_STATUSES } from '@/constants/moderation.js';
import { LOADER_STATUSES } from 'commons/constants/status.js';

export default {
    props: {
        status: VueTypes.status.isRequired,
        errorMessage: VueTypes.string,
        errorSubtitle: VueTypes.string,
        actions: VueTypes.array,
    },

    created() {
        this.error = ICON_STATUSES.ERROR;
    },

    computed: {
        isSuccessful() {
            return this.status === LOADER_STATUSES.SUCCESS;
        },

        isPending() {
            return this.status === LOADER_STATUSES.PENDING;
        },

        hasError() {
            return this.status === LOADER_STATUSES.ERROR;
        },
    },
    components: {
        vfSpinningLoader,
        ctaState,
    },
};
</script>

<style lang="scss">
    .vf-loading-wrapper {
        height: 100%;
    }

    .vf-spinning-loader-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
</style>
